import { Link, useParams } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";
import { authClient } from "../lib/auth";
import { EmptyState, Spinner } from "../components/ui";
import { ProfileBody, useStampTap } from "../components/Profile";
import { Wordmark } from "../components/Wordmark";

/**
 * A card reached by its share link, /p/<slug>. Works signed out. The server
 * answers only while the owner has it set to "Anyone with the link"; every
 * other case gets the same page as a link that never existed.
 */
export function SharedCardPage() {
  const { slug } = useParams({ from: "/p/$slug" });
  const session = authClient.useSession();
  const card = useQuery({ queryKey: ["shared-card", slug], queryFn: () => api.sharedProfile(slug), retry: false });
  const { tap, node } = useStampTap({ name: card.data?.name ?? "" });
  const signedIn = Boolean(session.data);
  return (
    <main className="page shared-card">
      <header className="topbar"><Link to={signedIn ? "/clubs" : "/"} search={signedIn ? { all: true } : { next: undefined }} className="row" aria-label="Pagemates"><Wordmark /></Link></header>
      {card.isPending ? <Spinner />
        : card.data ? <ProfileBody card={card.data} onStamp={tap} />
        : <EmptyState title="This profile isn't available" action={signedIn ? <Link to="/clubs" search={{ all: true }} className="btn primary">Go to your clubs</Link> : <Link to="/" search={{ next: undefined }} className="btn primary">What is Pagemates?</Link>}>
            It may be private, or the link is wrong.
          </EmptyState>}
      {node}
    </main>
  );
}
